import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/auth';

const AdminRoute = () => {
    const { isAdmin} = useAuth();
    if (isAdmin()) {
        return <Outlet />;
    } else {
        <Navigate to={'/home'} />;
    }
};

export default AdminRoute;
